// extracted by mini-css-extract-plugin
export default {"MessageEditor":"styles_MessageEditor__6i1ix","welcome":"styles_welcome__NmUmv","buttons":"styles_buttons__-URCt","cancelButton":"styles_cancelButton__lcPHC"};